import { HttpClient } from "@angular/common/http";
import { Apollo } from "apollo-angular";
import { CookieService } from "ngx-cookie-service";
import { environment } from "../../../environments/environment";
import { Injectable } from "@angular/core";
import { FETCH_CART_QUERY, DELETE_CART_QUERY, UPDATE_CART_QUERY } from "./queries.cart";
import { BaseService, LanguageService } from "imakeapp-shared";


@Injectable()

export class CartService extends BaseService
{


  constructor(
    private http: HttpClient,
    private apollo: Apollo,
    public override language_s: LanguageService
  ) {

    super(language_s);
console.log(this.lang)
  }



request_add_to_cart(variables: any)
{

  return this.http.post(`${environment.ApiEndPoint}/orders/addToCart`, variables);
}

add_to_cart(variables: any)
{
  return this.http.post(`${environment.ApiEndPoint}/orders/addToCart`, variables);

}
get_cart_total(body: any)
{
  return this.http.post(`${environment.ApiEndPoint}/products/calculateOrder`, body);
}
get_cart(variables: any)
{




  return this.apollo.watchQuery({
    query: FETCH_CART_QUERY(this.lang || "ar"),
    variables: variables,
    fetchPolicy: 'no-cache'
  }).valueChanges;

}

delete_cart(variables: any)
{

  return this.apollo.watchQuery({
    query: DELETE_CART_QUERY,
    variables: variables,
    fetchPolicy: 'no-cache'
  }).valueChanges;

}


update_cart(variables: any)
{
  return this.apollo.watchQuery({
    query: UPDATE_CART_QUERY,
    variables: variables,
    fetchPolicy: 'no-cache'
  }).valueChanges;

}

}
